
import "../../components/decodingWidget/DecodingWidget.css";
import DecodingWidget from "../../components/decodingWidget/DecodingWidget";

import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";

export default function Decoding() {
  return (
      <div>
    <Topbar />
    <div className="container">

    <Sidebar />
    <div className="home">
      <div className="homeWidgets">
        <DecodingWidget/>
      </div>
      
    </div>
    </div>
    </div>
  );
}